<main class="scrollMain">
  <div class="row">
    <div class="col-lg-12 dialog-title">
      <h1>{{ "Scheduler" | translate }}</h1>
    </div>
  </div>


  <section class="loading-container-finalize" *ngIf="!isLoadingSave">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing" >{{ "Loading" | translate }}</p>
  </section>
  <ng-template #loading>
    <section  class="dialog-loading-container">
      <div  class="pulsing" >
        <mat-spinner [diameter]="50" ></mat-spinner>
      </div>
      <p class="pulsing" >{{ "Loading" | translate }}...</p>
    </section>
  </ng-template>

<mat-dialog-content
  *ngIf="dataLoading$ |async as test ; else loading"
  [ngClass]="{'contenido-deshabilitado': !isLoadingSave}">
  <!-- Oppen form  -->
  <form [formGroup]="appointmentForm" >
    <section class="overflow-hidden owner">
           <!-- head owner -->
            <h2 class="section-title">
              {{"OwnerData" | translate}}
              <i
                class="bi bi-pencil-fill edit"
                (click)="enableFields()"
                *ngIf="isEditable"
              ></i>
            </h2>

            <mat-button-toggle-group class="owner__options" *ngIf="editButton">
              <mat-button-toggle (click)="editOwner()">
                {{"EditOwner" | translate}}
              </mat-button-toggle>
              <mat-button-toggle (click)="updateOwner()">
                {{"UpdateOwner" | translate}}
              </mat-button-toggle>
            </mat-button-toggle-group>

          <!-- label information Start -->
          <div class="schedule-reschedule-dialog__grid" *ngIf="!isEditingOwner && appointment?.customerVehicleData; else fields">
              <p class="owner__data-field">
                <span class="bold">{{"FirstName" | translate}}: </span>{{
                  firstNamesControl.value }}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"LastName" | translate}}: </span>{{
                  lastNamesControl.value }}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"DocumentType" | translate}}: </span>{{
                  customerDocumentTypeName | translate}}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"DocumentNumber" | translate}}: </span>{{
                  numberOfDocumentControl.value }}
              </p>
              <p class="owner__data-field">
                <span class="bold"
                  >{{"CustomerVehicleRelationship" | translate}}: </span
                >{{relationshipCustomerVehicleName | translate}}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"Phone" | translate}}: </span>{{ phoneControl.value
                }}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"Email" | translate}}: </span>{{ emailControl.value }}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"Plate" | translate}}: </span>{{ plateControl.value }}
              </p>
              <p class="owner__data-field">
                <span class="bold">{{"VIN" | translate}}: </span>{{ vinControl.value }}
              </p>
          </div>
          <!-- label information end -->

           <!-- Input information Start -->
          <ng-template #fields >
          <div  class="owner-form schedule-reschedule-dialog__grid" formGroupName="owner">
                <mat-form-field class="dialog__form-field">
                  <label class="dialog__label">{{ "FirstName" | translate }}</label>
                  <input
                    type="text"
                    matInput
                    formControlName="firstNames"
                   oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                    maxlength="50"/>
                  <mat-error *ngIf="firstNamesControl!.hasError('required')">
                    {{ "NameIs" | translate }} <strong>{{ "Required" | translate }}</strong>
                  </mat-error>
                  <mat-error *ngIf="firstNamesControl!.hasError('noSpecialChars')">
                    {{ "SpecialCharacters" | translate }}
                    <strong>{{ "NotAllowed" | translate }}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="dialog__form-field">
                  <label class="dialog__label">{{ "LastName" | translate }}</label>
                  <input
                    type="text"
                    matInput
                    formControlName="lastNames"
                   oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                    maxlength="50"/>
                  <mat-error *ngIf="lastNamesControl!.hasError('required')">
                    {{ "LastNameIs" | translate }}
                    <strong>{{ "Required" | translate }}</strong>
                  </mat-error>
                  <mat-error>
                    {{ "SpecialCharacters" | translate }}
                    <strong>{{ "NotAllowed" | translate }}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="dialog__form-field">
                  <label class="dialog__label">{{ "DocumentType" | translate }}</label>
                  <mat-select formControlName="typeOfDocument">
                    <mat-option
                    *ngFor="let typeOfDocument of documentType$|async"
                    [value]="typeOfDocument.typeId"
                    >{{typeOfDocument.typeName}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="typeOfDocumentControl!.hasError('required')">
                    {{"DocumentTypeIs" | translate}}
                    <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="dialog__form-field">
                  <label class="dialog__label">{{ "DocumentNumber" | translate }}</label>
                  <input
                    type="text"
                    matInput
                    formControlName="numberOfDocument"
                   oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                    maxlength="15"/>
                  <mat-error>
                    {{ "DocumentNumberIs" | translate }}
                    <strong>{{ "Required" | translate }}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>{{"CustomerVehicleRelationship" | translate}}</mat-label>
                  <mat-select formControlName="relationshipCustomerVehicle">
                    <mat-option
                      *ngFor="let relation of relationshipCustomerVehicle$|async"
                      [value]="relation.relationshipVehicleId"
                    >
                      {{relation.relationshipName | translate}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="relationshipCustomerVehicleControl!.hasError('required')">
                    {{"RelationshipIs" | translate}}
                    <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>{{"Phone" | translate}}</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="phone"
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    maxlength="15"
                  />
                  <mat-error *ngIf="phoneControl!.hasError('numbersOnly')">
                    {{ 'onlyNumbersAllowed' | translate }}
                  </mat-error>
                  <mat-error *ngIf="phoneControl!.hasError('required')">
                    {{"PhoneIs" | translate}}
                    <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>{{"Email" | translate}}</mat-label>
                  <input
                    type="email"
                    matInput formControlName="email"
                    maxlength="50"
                  />
                  <mat-error *ngIf="emailControl!.hasError('invalidEmail')">
                    {{"EmailNotValid" | translate}}
                  </mat-error>
                  <mat-error *ngIf="emailControl!.hasError('required')">
                    {{"EmailIs" | translate}}
                    <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field >
                  <mat-label>{{"Plate" | translate}}</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="plate"
                   oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                    maxlength="10"
                    minlength="5"
                  />
                  <mat-error *ngIf="plateControl!.hasError('required')">
                    {{"PlateIs" | translate}}
                    <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                  <mat-error *ngIf="plateControl!.hasError('minlength')">
                    {{"PlateMustHave" | translate}}
                    <strong>{{"MinimumFiveCharacters" | translate}}</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field >
                  <mat-label>{{"VIN" | translate}}</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="vin"
                    maxlength="17"
                   oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                    required
                  />
                  <mat-error *ngIf="appointmentForm.get('owner')?.get('vin')!.hasError('required')">
                    {{"VinIs" | translate}} <strong>{{"Required" | translate}}</strong>
                  </mat-error>
                  <mat-error *ngIf="appointmentForm.get('owner')?.get('vin')!.hasError('noSpecialChars')">
                    {{"OnlyAlphanumericCharacters" | translate}}
                  </mat-error>
                  <mat-error *ngIf="appointmentForm.get('owner')?.get('vin')!.hasError('minlength')">
                    {{"VinMust" | translate}}
                    <strong>{{"MinimumFiveCharacters" | translate}}</strong>
                  </mat-error>
                </mat-form-field>
          </div>
          </ng-template>

       <!-- Input information End -->

      <!-- Info reservation data -->
      <ng-container class="reservation">
        <h2 class="section-title">{{"ReservationData" | translate}}</h2>

        <div
          class="row"
          formGroupName="scheduled"
        >
          <ng-container *ngIf="isThereABlockForRole; else schedule">
            <h2 class="errorBloqueo">{{"CantSchedule" | translate}}</h2>
          </ng-container>

          <ng-template #schedule>
            <div class="col-lg-6">
              <p class="owner__data-field">
                <span class="bold">{{"Brand" | translate}}: </span
                >{{appointment.selectedMake.Description}}
              </p>
            </div>
            <div class="col-lg-6">
              <p class="owner__data-field">
                <span class="bold">{{"City" | translate}}: </span
                >{{appointment.selectedLocation.Description}}
              </p>
            </div>
            <div class="col-lg-6">
              <p class="owner__data-field">
                <span class="bold">{{"TypeOfService" | translate}}: </span
                >{{appointment.selectedService.Name}}
              </p>
            </div>
            <div class="col-lg-6">
              <p class="owner__data-field">
                <span class="bold">{{"Workshop" | translate}}: </span
                >{{appointment.selectedCompany.Description}}
              </p>
            </div>

            <div class="col-lg-6">
              <p class="owner__data-field">
                <span class="bold">{{"Advisor" | translate}}: </span
                >{{appointment.selectedResource.Description}}
              </p>
            </div>

            <div class="col-lg-6">
              <mat-form-field>
                <mat-label>{{"Mileage" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="mileage"
                  oninput="value = value.replace(/[^0-9 ]/g, '')"
                  maxlength="6"
                />
                <mat-error *ngIf="mileageControl!.hasError('required')">
                  {{"MileageIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
                <mat-error *ngIf="mileageControl!.hasError('noSpecialChars')">
                  {{"OnlyAlphanumericCharacters" | translate}}
                </mat-error>
                <mat-error *ngIf="mileageControl!.hasError('numbersOnly')">
                  {{ 'onlyNumbersAllowed' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field>
                <mat-label>{{"Channel" | translate}}</mat-label>
                <mat-select formControlName="channel">
                  <mat-option
                    *ngFor="let channel of channel"
                    [value]="channel"
                    >{{channel}}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-12">
              <mat-form-field>
                <mat-label>{{"Observations" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="observation"
                oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
                  maxlength="100"
                  (input)="charCount = appointmentForm.get('scheduled')?.get('observation')?.value?.length || 0"
                />
                <mat-hint align="start">{{ charCount }}/100</mat-hint>
              </mat-form-field>
            </div>

          </ng-template>

        </div>
      </ng-container>
      <!-- Info reservation data end -->

      <!-- Representative Data start -->
      <div formGroupName="representative">
        <div class="schedule-reschedule-dialog__radios">
          <div class="">
            <p>{{"OwnerWillBeOnSite" | translate}}</p>
          </div>
          <div class="">
            <mat-radio-group
                  aria-label="Select an option"
                  formControlName ="willOwnerShowUp"
                  [(ngModel)]="isEditingRepresentative"
                >
                  <mat-radio-button  [value]="true" labelPosition="before"
                    >{{"Yes" | translate}}</mat-radio-button
                  >
                  <mat-radio-button  [value]="false" labelPosition="before"
                    >{{"No" | translate}}</mat-radio-button
                  >
                </mat-radio-group>
          </div>
        </div>

        <section *ngIf="!isEditingRepresentative">
            <h2 class="section-title">
              {{"RepresentativeInformation" | translate}}
            </h2>

            <section class="schedule-reschedule-dialog__grid">
              <mat-form-field>
                <mat-label>{{"FirstName" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="namesRepresentative"
                  maxlength="50"
                 oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                />
                <mat-error *ngIf="namesRepresentativeControl!.hasError('required')">
                  {{"NameIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
                <mat-error
                  *ngIf="namesRepresentativeControl!.hasError('noSpecialChars')"
                >
                  {{"SpecialCharacters" | translate}}
                  <strong>{{"NotAllowed" | translate}}</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{"LastName" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="lastnamesRepresentative"
                 oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                  maxlength="50"
                />
                <mat-error *ngIf="lastnamesRepresentativeControl!.hasError('required')">
                  {{"LastNameIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
                <mat-error
                  *ngIf="lastnamesRepresentativeControl!.hasError('noSpecialChars')"
                >
                  {{"SpecialCharacters" | translate}}
                  <strong>{{"NotAllowed" | translate}}</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field class="dialog__form-field">
                <label class="dialog__label">{{ "DocumentType" | translate }}</label>
                <mat-select formControlName="typeOfDocumentRepresentative">
                  <mat-option
                  *ngFor="let typeOfDocument of documentType$|async"
                  [value]="typeOfDocument.typeId"
                  >{{typeOfDocument.typeName}}</mat-option>
                </mat-select>
                <mat-error *ngIf="typeOfDocumentRepresentativeControl!.hasError('required')">
                  {{"DocumentTypeIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{"DocumentNumber" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="numberOfDocumentRepresentative"
                  oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                  maxlength="15"
                />
                <mat-error
                  *ngIf="numberOfDocumentRepresentativeControl!.hasError('required')"
                >
                  {{"DocumentNumberIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{"Phone" | translate}}</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="phoneRepresentative"
                  oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                  maxlength="15"
                />
                <mat-error *ngIf="phoneRepresentativeControl!.hasError('numbersOnly')">
                  {{ 'onlyNumbersAllowed' | translate }}
                </mat-error>
                <mat-error *ngIf="phoneRepresentativeControl!.hasError('required')">
                  {{"PhoneIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{"Email" | translate}}</mat-label>
                <input
                  type="email"
                  matInput
                  formControlName="emailRepresentative"
                  maxlength="50"
                />
                <mat-error *ngIf="emailRepresentativeControl!.hasError('email')">
                  {{"EmailNotValid" | translate}}
                </mat-error>
                <mat-error *ngIf="emailRepresentativeControl.hasError('required')">
                  {{"EmailIs" | translate}}
                  <strong>{{"Required" | translate}}</strong>
                </mat-error>
              </mat-form-field>
            </section>
          </section>
        </div>

        <section class="termsAndPolitics">

          <div class="" formGroupName="termsAndPolitics">

            <div class="col-lg-12">
              <div class="row">
                <div
                  class="col-lg-6">

                  <p>
                    {{"IAgree" | translate}}
                    <span>
                      <a class="highlight" >
                        {{"TermsAndConditions" | translate}}
                      </a></span
                    >
                  </p>
              <mat-error
                *ngIf="termsControl!.hasError('yesSelected') && termsControl!.dirty && termsControl!.value=='no' "
              >
                {{"MustAgreeToTermsAndConditions" | translate}}
              </mat-error>

                </div>

                <div class="col-lg-6">
                  <mat-radio-group
                    aria-label="Select an option"
                    formControlName="terms"
                  >
                    <mat-radio-button value="si" labelPosition="before"
                      >{{"Yes" | translate}}</mat-radio-button
                    >
                    <mat-radio-button value="no" labelPosition="before"
                      >{{"No" | translate}}</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="row">
                <div
                  class="col-lg-6">

                  <p>
                    {{"DeclareToKnowAndUnderstand"| translate}}
                    <span>
                      <a class="highlight" >
                        {{"PersonalDataProtectionPolicy" | translate}}
                      </a></span
                    >
                  </p>
              <mat-error
                *ngIf="policiesControl!.hasError('yesSelected') && policiesControl!.dirty && policiesControl!.value=='no' "
              >
                {{"MustAgreeToTermsAndConditions" | translate}}
              </mat-error>

                </div>

                <div class="col-lg-6">
                  <mat-radio-group
                    aria-label="Select an option"
                    formControlName="policies"
                  >
                    <mat-radio-button value="si" labelPosition="before"
                      >{{"Yes" | translate}}</mat-radio-button
                    >
                    <mat-radio-button value="no" labelPosition="before"
                      >{{"No" | translate}}</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
           </div>
          </section>



      <!-- Representative Data end -->

    </section>
  </form>





    <!-- End terminos condiciones politicas-->
    <ng-template #loading>

      <section class="dialog-loading-container" *ngIf="false">
        <div  class="pulsing" >
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing" >{{ "LoadingData" | translate }}</p>
      </section>
    </ng-template>


    <section class="dialog-loading-container" *ngIf="false">
      <div  class="pulsing" >
        <mat-spinner [diameter]="50" ></mat-spinner>
      </div>
      <p class="pulsing" >{{ "SavingSchedule" | translate }}</p>
    </section>


</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-dialog-close class="dialog__button">
    {{"Cancel" | translate}}
  </button>
  <button
    class="dialog__button"
    [ngClass]="appointmentForm.invalid ? 'dialog__button--disabled' : 'dialog__button--fill'"
    (click)="onSave()"
    [disabled]= "formsValidations() "
  >
    {{"Accept" | translate}}
  </button>

</mat-dialog-actions>

